module.exports = __webpack_public_path__ + "static/media/in-progress.c45d2bd4.png";